import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { PATH_APP } from 'routes/paths';
import { isMobeatStaff } from 'utils/mobeatStaff';

export default function AdminHomeRedirect() {
  const { user } = useAuth();
  if (isMobeatStaff(user?.organizationRole)) {
    return <Navigate to={PATH_APP.admin.demoLeads} replace />;
  }
  return <Navigate to='/admin/applications' replace />;
}
